import Clarity from "@microsoft/clarity";

export function initClarity() {
  if (process.env.NEXT_PUBLIC_ENV !== "PRODUCTION") return;
  if ((window as any).clarity) return;
  const projectId = process.env.NEXT_PUBLIC_MS_CLARITY_PROJECT_ID;
  if (!projectId) {
    console.log("Microsoft Clarity not initialized: missing project ID.");
    return;
  }
  Clarity.init(projectId);
}
